import gsap from 'gsap'
import state from '../state'
import SplitText from 'gsap/SplitText'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { q1O, q1IO } from '../util/nE'
import Flickity from 'flickity'
gsap.registerPlugin(SplitText, ScrollTrigger)

class Testimonials {
  constructor (el) {
    this.el = el
    this.list = this.el.querySelector('.testimonials__list')
    this.items = this.el.querySelectorAll('.testimonials__item')
    this.decoSVG = this.el.querySelector('.testimonials__deco-svg')
    this.decoCircle = this.decoSVG.querySelector('circle')
    this.current = this.el.querySelector('.current')
    this.next = this.el.querySelector('.next')
    this.all = this.el.querySelector('.all')
    this.index = this.el.querySelector('.testimonials__index')
    this.author = this.el.querySelector('.testimonials__author')
    this.quote = this.el.querySelector('.testimonials__quote svg')
  }

  init () {
    this.isXl = false
    const mm = gsap.matchMedia()
    mm.add(state.queries.xl, () => {
      this.isXl = true
    })

    this.buildSplit()
    this.buildTimelineIn()
    this.bindClicks()

    if (this.items.length > 1) {
      this.buildFlickity()

      if (this.isXl) {
        this.buildCursor()
      }
    }
  }

  buildTimelineIn () {
    const radius = 342
    const circumference = radius * 2 * Math.PI
    this.decoCircle.style.strokeDasharray = `${circumference} ${circumference}`
    this.decoCircle.style.strokeDashoffset = `${circumference}`

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.el,
      },
      defaults: {
        ease: (t) => {
          return q1O(t)
        },
        duration: 1.4,
      },
    })

    tl.set(this.el, { autoAlpha: 1 })
    tl.fromTo(
      this.el, {
        backgroundColor: '#fff',
      },
      {
        backgroundColor: '#101212',
        duration: 2,
      }, 0
    )
    tl.to(this.decoCircle, {
      strokeDashoffset: 0,
      duration: 2,
      ease: (t) => {
        return q1IO(t)
      },
    }, 0)

    tl.fromTo(this.split.chars, {
      yPercent: 100,
      autoAlpha: 0,
    }, {
      yPercent: 0,
      autoAlpha: 1,
      stagger: 0.003,
    }, 0)

    tl.fromTo(this.quote, {
      y: 100,
      autoAlpha: 0,
    }, {
      y: 0,
      autoAlpha: 1,
    }, 0)

    tl.fromTo([this.author.querySelectorAll('*'), this.index], {
      yPercent: 100,
      autoAlpha: 0,
    }, {
      yPercent: 0,
      autoAlpha: 1,
      stagger: 0.05,
    }, 0.4)
  }

  buildFlickity () {
    this.flickity = new Flickity(this.list, {
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      imagesLoaded: true,
      selectedAttraction: 0.03,
      friction: 0.4,
      draggable: false,
      // cellAlign: 'center',
      percentPosition: true,
    })
  }

  buildCursor () {
    this.current.innerHTML = (this.flickity.selectedIndex + 1) < 10 ? `0${this.flickity.selectedIndex + 1}` : this.flickity.selectedIndex + 1
    this.all.innerHTML = this.items.length < 10 ? `0${this.items.length}` : this.items.length
  }

  bindClicks () {
    this.el.addEventListener('click', (e) => {
      e.preventDefault()
      this.flickity.next()
      this.current.innerHTML = (this.flickity.selectedIndex + 1) < 10 ? `0${this.flickity.selectedIndex + 1}` : this.flickity.selectedIndex + 1
    })
  }

  buildSplit () {
    this.split = new SplitText(this.items[0].querySelector('.testimonials__quote-text'), {
      type: 'chars, words, lines',
      linesClass: 's-line u-t overflow-hidden',
      lineThreshold: 5,
    })
  }

  destroy () {
  }
}

export default Testimonials



//////////////////
// WEBPACK FOOTER
// ./scripts/components/Testimonials.js
// module id = 69
// module chunks = 0